// import React from "react";
//
// export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;
//
// export const Input: React.FC<InputProps> = ({ className, ...props }) => (
//   <input
//     {...props}
//     className={["input", className].filter(Boolean).join(" ")}
//   />
// );

// import React from "react";
//
// export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;
//
// export const Input: React.FC<InputProps> = (props) => <input {...props} />;

import React from "react";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input: React.FC<InputProps> = ({ className, ...props }) => (
  <input className={className} {...props} />
);